import {
  getProcurementIntegrationDossier,
  reprocessIntegration,
  reprocessIntegrationBatch,
} from '@/resources/admin/integrations';

const actions = {
  async fetchProcurementDossier(_context, procurementId) {
    const response = await getProcurementIntegrationDossier(procurementId);

    if (response.status < 200 || response.status >= 300) {
      return Promise.reject(response.data);
    }

    return Promise.resolve((response.data && response.data.data) || response.data);
  },
  async reprocessIntegration(_context, payload) {
    const response = await reprocessIntegration(payload);

    if (response.status < 200 || response.status >= 300) {
      return Promise.reject(response.data);
    }

    return Promise.resolve((response.data && response.data.data) || response.data);
  },
  async reprocessIntegrationBatch(_context, payload) {
    const response = await reprocessIntegrationBatch(payload);

    if (response.status < 200 || response.status >= 300) {
      return Promise.reject(response.data);
    }

    return Promise.resolve((response.data && response.data.data) || response.data);
  },
};

export default {
  namespaced: true,
  actions,
};
